export default __webpack_public_path__ + "static/media/purple-heart.04837446.svg";